import { clamp } from '@styles/utils/conversion.style'
import { grid } from '@styles/vars/grid.style'
import styled from 'styled-components'

export const GalleryMain = styled.section`
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  ${clamp('grid-column-gap', grid.gap.min, grid.gap.max)}
`

export const GalleryBlock = styled.div`
  grid-column: ${props => (props.large ? 'span 5' : 'span 3')};
`
